<template>
  <div>
    <v-btn class="botonqr" small round color="primary" @click="scanQR = true" @click.prevent="">
    <v-icon>mdi-qrcode</v-icon> QR
    </v-btn>


    <div class="container">
      <qrcode-stream :constraints="{ facingMode  }"  @error="onError" @decode="onDetect"  v-if="scanQR == true">
        <button @click="switchCamera">
          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-camera" viewBox="0 0 16 16">
            <path d="M15 12a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1V6a1 1 0 0 1 1-1h1.172a3 3 0 0 0 2.12-.879l.83-.828A1 1 0 0 1 6.827 3h2.344a1 1 0 0 1 .707.293l.828.828A3 3 0 0 0 12.828 5H14a1 1 0 0 1 1 1zM2 4a2 2 0 0 0-2 2v6a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2h-1.172a2 2 0 0 1-1.414-.586l-.828-.828A2 2 0 0 0 9.172 2H6.828a2 2 0 0 0-1.414.586l-.828.828A2 2 0 0 1 3.172 4z"/>
            <path d="M8 11a2.5 2.5 0 1 1 0-5 2.5 2.5 0 0 1 0 5m0 1a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7M3 6.5a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0"/>
          </svg>
        </button>
      </qrcode-stream>
    </div>
  </div>
</template>

<script setup>
import { QrcodeStream } from "vue-qrcode-reader";
import { ref, onMounted } from "vue";
import { defineEmits } from 'vue';

// Define the emit function to be used in the setup
const emit = defineEmits(['qr-detected']);
const result = ref("");
let scanQR = ref(false);

function onDetect(detectedCodes) {
  // console.log(detectedCodes);
  // result.value = JSON.stringify(detectedCodes.map((code) => code.content));
  result.value = detectedCodes;
  emit('qr-detected', result.value);
  // console.log("result.value",result.value)
  scanQR.value = false;
}

/*** select camera ***/
const selectedDevice = ref(null);
const devices = ref([]);

onMounted(async () => {
  devices.value = (await navigator.mediaDevices.enumerateDevices()).filter(({ kind }) => kind === "videoinput");

  if (devices.value.length > 0) {
    selectedDevice.value = devices.value[0];
  }
});

let facingMode = ref("environment");

function switchCamera() {
  switch (facingMode.value) {
    case "environment":
      facingMode.value = "user";
      break;
    case "user":
      facingMode.value = "environment";
      break;
  }
}

/*** error handling ***/

const error = ref("");

function onError(err) {
  error.value = `[${err.name}]: `;

  if (err.name === "NotAllowedError") {
    error.value += "you need to grant camera access permission";
  } else if (err.name === "NotFoundError") {
    error.value += "no camera on this device";
  } else if (err.name === "NotSupportedError") {
    error.value += "secure context required (HTTPS, localhost)";
  } else if (err.name === "NotReadableError") {
    error.value += "is the camera already in use?";
  } else if (err.name === "OverconstrainedError") {
    error.value += "installed cameras are not suitable";
  } else if (err.name === "StreamApiNotSupportedError") {
    error.value += "Stream API is not supported in this browser";
  } else if (err.name === "InsecureContextError") {
    error.value += "Camera access is only permitted in secure context. Use HTTPS or localhost rather than HTTP.";
  } else {
    error.value += err.message;
  }
}
</script>

<style scoped>
.container {
  width: 100%;
}

button {
  margin-bottom: 20px;
}
.botonqr{
  margin-left:25%;
}
.loading-indicator {
  font-weight: bold;
  font-size: 2rem;
  text-align: center;
}
.qrcode-stream-wrapper {
    width: 100%;
    height: 100%;
    position: relative;
    z-index: 0;
}

@media only screen and (max-width: 2400px) {
  .container {
   width: 500px;
  margin-left: -113%;
  
}
}
@media only screen and (max-width: 1451px) {
  .container {
   width: 500px;
  margin-left: -146%;
  
}
}
@media only screen and (max-width: 1255px) {
  .container {
   width: 500px;
  margin-left: -176%;
  
}
}

@media only screen and (max-width: 960px) {
  .container {
  width: 100%;
  margin-left: 0%;
  
}
}
</style>
